import React from "react"

const BackgroundOverlay = () => {
  return (
    <div className="absolute inset-0 pointer-events-none">
      {/* Background gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-canvas/50 to-canvas opacity-60" />
      
      {/* Optional decorative elements */}
      <div className="absolute top-20 left-10 w-64 h-64 bg-gradient-to-r from-primary/10 to-secondary/10 rounded-full blur-3xl opacity-30" />
      <div className="absolute bottom-20 right-10 w-80 h-80 bg-gradient-to-l from-accent/10 to-primary/10 rounded-full blur-3xl opacity-20" />
    </div>
  )
}

export default BackgroundOverlay